module.exports = __webpack_public_path__ + "static/img/pic_bg.56139af7.png";